'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconBellOn, iconBellOnTag } from '@ni/nimble-components/dist/esm/icons/bell-on';
import { wrap } from '../../utilities/react-wrapper';

export type { IconBellOn };
export { iconBellOnTag };
export const NimbleIconBellOn = wrap(IconBellOn);